import constants from '../Constants';

const { TOGGLE_MODAL, SET_MODAL_DATA } = constants;

const INIT_STATE = { 
                types: { 
                    add: { modal: false, data: {} },
                    edit: { modal: false, data: {}} 
                },
                locations: {
                    add: { modal: false, data: {}},
                    edit: { modal: false, data: {}}
                },
                subLocations: {
                    display: { modal: false, data: {}},
                    add: { modal: false, data: {}}
                },
                users: {
                    add: { modal: false, data: {}},
                    edit: { modal: false, data: {}}
                },
                jobs: {
                    add: { modal: false, data: {}},
                    edit: { modal: false, data: {}},
                    quickAdd: { modal: false, data: {}},
                    search: { modal: false, data: {}},
                    logs: { modal: false, data: {}},
                },
                companies: {
                    add: { modal: false, data: {}},
                    edit: { modal: false, data: {}}
                }
             };

const ModalReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TOGGLE_MODAL:{
      const { endpoint, method } = action.payload;
      const { [endpoint]: endpointState, [endpoint]: { [method]: modalState } } = state;
      const  { modal }  = modalState;
      return { ...state, [endpoint]: { ...endpointState, [method]: {...modalState, modal: !modal } } };
    }

    case SET_MODAL_DATA:{
      const { endpoint, method, data } = action.payload;
      const { [endpoint]: endpointState, [endpoint]: { [method]: modalState } } = state;
      
      return { ...state, [endpoint]: {...endpointState, [method]:{ ...modalState, data } } };
    }

    default:{
        return state;
    }
  }
}

export default ModalReducer;


// WEBPACK FOOTER //
// ./src/Reducers/ModalReducer.js